//
//  FIlterDialog.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import {
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";

interface FilterDialogProps {
  open: boolean;
  onClose: () => void;
  allFilters: string[];
  checkedFilters: string[];
  checkedAll: boolean;
  handleChecked: (name: string, isAll: boolean) => void;
}

const allText = "All";

const FilterDialog: React.FC<FilterDialogProps> = ({
  open,
  onClose,
  allFilters,
  checkedFilters,
  checkedAll,
  handleChecked,
}) => {
  return (
    <Dialog open={open} onClose={onClose} disableEnforceFocus>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          minWidth: 200,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={checkedAll}
              onChange={() => handleChecked(allText, true)}
            />
          }
          label={allText}
        />
        {allFilters.map((filterName) => (
          <FormControlLabel
            key={filterName}
            control={
              <Checkbox
                checked={checkedFilters.includes(filterName)}
                onChange={() => handleChecked(filterName, false)}
              />
            }
            label={filterName}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
